import { IoAddOutline } from 'react-icons/io5'
import { vccBtn } from '@shared/ui/vccButtons'
import { vccButtonLabel, type VccActionButtonProps } from './vccButtonProps'

export type AddButtonProps = VccActionButtonProps

export default function AddButton({
  onClick,
  disabled,
  type = 'button',
  className = '',
  showIcon = true,
  loading = false,
  loadingLabel = 'Adding...',
  label = 'Add',
  children,
  ...rest
}: AddButtonProps) {
  return (
    <button
      type={type}
      className={`${vccBtn('add')} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled || loading}
      {...rest}
    >
      {showIcon && !loading && <IoAddOutline aria-hidden className="vcc-btn__icon" />}
      {vccButtonLabel({ children, label, loading, loadingLabel }, label)}
    </button>
  )
}
